import { HttpRequest3fsc4149kgwfg as HttpRequest } from './HttpRequest.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultHttpRequestClass;
function DefaultHttpRequest() {
  if (DefaultHttpRequestClass === VOID) {
    class $ {
      constructor(call, data) {
        this.call_1 = call;
        this.method_1 = data.method_1;
        this.url_1 = data.url_1;
        this.content_1 = data.body_1;
        this.headers_1 = data.headers_1;
        this.attributes_1 = data.attributes_1;
      }
      get_call_wojxrb_k$() {
        return this.call_1;
      }
      get_coroutineContext_115oqo_k$() {
        return this.get_call_wojxrb_k$().get_coroutineContext_115oqo_k$();
      }
      get_method_gl8esq_k$() {
        return this.method_1;
      }
      get_url_18iuii_k$() {
        return this.url_1;
      }
      get_content_h02jrk_k$() {
        return this.content_1;
      }
      get_headers_ef25jx_k$() {
        return this.headers_1;
      }
      get_attributes_dgqof4_k$() {
        return this.attributes_1;
      }
    }
    initMetadataForClass($, 'DefaultHttpRequest', VOID, VOID, [HttpRequest()]);
    DefaultHttpRequestClass = $;
  }
  return DefaultHttpRequestClass;
}
//region block: exports
export {
  DefaultHttpRequest as DefaultHttpRequest19v463zllbymg,
};
//endregion

//# sourceMappingURL=DefaultHttpRequest.mjs.map
